import { ParameterType, Type } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';

export function createTrainResponse() : ParameterType
{
    const usageType = ApiRef.getType("TrainUsage");

    const desc = (<>
        <p>This is the standard (non-streaming) response format returned by the Train endpoint. It contains 
           performance metrics for each training example and usage statistics for the training operation.</p>
        </>);

    return {
        id          : "TrainResponse",
        name        : "TrainResponse",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "performance",
                "type"        : "TrainPerformance[]",
                "description" : <><p>An array of performance metrics, one for each response sample provided in the 
                                     training data.</p></>,
                "optional"    : false
            },
            {
                "name"        : "usage",
                "type"        : "TrainUsage",
                "description" : <><p>Usage statistics for the training operation.</p>{ usageType.description }</>,
                "optional"    : false
            }
        ]
    };
}

